export default {
  path: '/display/:code',
  name: 'r_display',
  meta: {},
  component: () => import('../../components/displays/Display.vue'),
};
